// Eye patch capping: limits specific variants to 1 per cart. Wrapped in an IIFE
// so nothing leaks to global scope (avoids clashing with popup-bundle.js).
(() => {
  // Extra capped variant ids from the cart_mode_price_set_for_ip metaobject,
  // merged on top of the hardcoded ids below.
  const readDynamicCappedVariantIds = () => {
    const el = document.getElementById('eye-patch-capping-config');
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent);
      return String(data.capVariantIds || '')
        .split(',')
        .map((id) => Number(id.trim()))
        .filter((id) => id > 0);
    } catch (_) {
      return [];
    }
  };
  const CAPPED_VARIANT_IDS = [40325864751269, ...readDynamicCappedVariantIds()];
  const CAP_ENABLED_PATTERN = /^(?:1|true|yes|on)$/i;
  const POPUP_SELECTOR = '.popup-for-eyepatch';

  let isProcessing = false;

  const isCappingEnabled = () => {
    const capEl = document.getElementById('eye-patch-capping-on');
    return Boolean(capEl) && CAP_ENABLED_PATTERN.test(String(capEl.value).trim());
  };

  const resetButton = (button) => {
    isProcessing = false;
    if (button) button.disabled = false;
  };

  const openLimitPopup = () => {
    document.querySelector(POPUP_SELECTOR)?.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  };

  const closeLimitPopup = () => {
    document.querySelector(POPUP_SELECTOR)?.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  };

  // Same add flow as product-form.js, so the cart drawer refreshes/opens normally.
  const addCappedItemToCart = async (variantId, button) => {
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionId = cartDrawer?.dataset?.sectionId ?? 'cart-drawer';

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', 1);
    formData.set('properties[is_app]', 'true');

    cartDrawer?.openCart();

    try {
      const cartData = await CartAPI.add(formData, [sectionId]);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'eye-patch-capping', cartData });
      }

      cartDrawer?.renderContents(cartData);
    } catch (error) {
      console.error('eye-patch-capping: add to cart failed', error);
    } finally {
      resetButton(button);
    }
  };

  // Delegated from document so cards injected later are covered too.
  const handleAddClick = async (event) => {
    const wrapper = event.target.closest('.devx_eye_patch');
    if (!wrapper || !isCappingEnabled()) return;

    event.preventDefault();
    if (isProcessing) return;

    const variantId = Number(wrapper.querySelector('.dev_home_getvariantid')?.value);
    const button = wrapper.querySelector('button');
    if (!variantId || !button) return;

    isProcessing = true;
    button.disabled = true;

    if (!CAPPED_VARIANT_IDS.includes(variantId)) {
      await addCappedItemToCart(variantId, button);
      return;
    }

    try {
      const cart = await CartAPI.get();
      const existingItem = cart.items.find((item) => item.variant_id === variantId);

      if (existingItem?.quantity >= 1) {
        openLimitPopup();
        resetButton(button);
        return;
      }

      await addCappedItemToCart(variantId, button);
    } catch (error) {
      console.error('eye-patch-capping: cart lookup failed', error);
      resetButton(button);
    }
  };

  const handlePopupClick = (event) => {
    if (!event.target.closest(POPUP_SELECTOR)) return;
    if (!event.target.closest('.popup-close, .popup-button')) return;

    closeLimitPopup();
  };

  document.addEventListener('click', handleAddClick);
  document.addEventListener('click', handlePopupClick);
})();
